import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { Tabs } from 'antd';

import NavBar from '@sp/client/components/NavBar';

import {
  PLAN_TAB_TITLES as TAB_TITLES,
  PLAN_TABS as TABS,
} from '../../constants';

import PlanListFilters from '../../components/PlanListFilters';
import PlansTable from '../../components/PlansTable';

import * as actions from '../../actions';

import { CANCELLED_PLANS_TABLE_COLUMNS, PLANS_TABLE_COLUMNS } from './config';

const { TabPane } = Tabs;

const propTypes = {
  changePlansTab: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
};

const Plans = ({ activeTab, changePlansTab }) => (
  <NavBar withPadding>
    <PlanListFilters />
    <Tabs
      defaultActiveKey={TABS.ALL}
      activeKey={activeTab}
      animated={false}
      onChange={changePlansTab}
    >
      <TabPane tab={TAB_TITLES[TABS.ALL]} key={TABS.ALL}>
        <PlansTable columns={PLANS_TABLE_COLUMNS} />
      </TabPane>
      <TabPane tab={TAB_TITLES[TABS.CANCELLED]} key={TABS.CANCELLED}>
        <PlansTable columns={CANCELLED_PLANS_TABLE_COLUMNS} />
      </TabPane>
    </Tabs>
  </NavBar>
);

Plans.propTypes = propTypes;

const mapStateToProps = ({ admin: { activePlansTab } }) => ({
  activeTab: activePlansTab,
});

export default compose(
  connect(
    mapStateToProps,
    {
      fetchPlans: actions.fetchPlans,
      changePlansTab: actions.changePlansTab,
    },
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchPlans();
    },
  }),
)(Plans);
